/**
 * Created by vtbelo on 17/03/21
 */

const GrowingsPlanner = function (slot) {
    this.slot = slot;

    if (cleverapps.config.editorMode || cleverapps.config.adminMode) {
        return;
    }

    this.data = GrowingsPlanner.CONFIG[cleverapps.meta.selectedLocationId()];
    if (this.data) {
        this.load();
        this.planNext(this.getBetweenTimeout());
    }
};

GrowingsPlanner.prototype.getBetweenTimeout = function () {
    return cleverapps.parseInterval(this.data.betweenTimeouts[this.spawnOrder < this.data.betweenTimeouts.length ? this.spawnOrder : this.data.betweenTimeouts.length - 1]);
};

GrowingsPlanner.prototype.destructor = function () {
    this.clearPlanTimeout();
};

GrowingsPlanner.prototype.clearPlanTimeout = function () {
    if (this.planTimeout !== undefined) {
        clearTimeout(this.planTimeout);
        this.planTimeout = undefined;
    }
};

GrowingsPlanner.prototype.getFreeSlots = function () {
    const slots = [];
    const map = Map2d.currentMap;
    for (let y = 0; y < map.getHeight(); y++) {
        for (let x = 0; x < map.getWidth(); x++) {
            if (map.isEmpty(x, y)) {
                slots.push({ x, y });
            }
        }
    }
    return slots;
};

GrowingsPlanner.prototype.amountGrowings = function () {
    let amountGrowings = 0;
    const map = Map2d.currentMap;
    for (let y = 0; y < map.getHeight(); y++) {
        for (let x = 0; x < map.getWidth(); x++) {
            const unit = map.getUnit(x, y);
            if (unit) {
                for (let t = 0; t < this.data.units.length; t++) {
                    if (this.data.units[t].code === unit.code && this.data.units[t].stage === unit.stage) {
                        amountGrowings++;
                        break;
                    }
                }
            }
        }
    }
    return amountGrowings;
};

GrowingsPlanner.prototype.existFreeSlot = function () {
    const slots = this.getFreeSlots();
    return slots.length > 0;
};

GrowingsPlanner.prototype.getRandomSlot = function () {
    if (this.existFreeSlot() && this.amountGrowings() < this.data.maxAmount) {
        const pseudo = PseudoRandom.GET("secondary");
        pseudo.seed(Math.floor(Math.random() * 10000));

        return pseudo.choose(this.getFreeSlots());
    }
};

GrowingsPlanner.prototype.spawn = function () {
    const slot = this.getRandomSlot();
    if (slot) {
        const pseudo = PseudoRandom.GET("secondary");
        pseudo.seed(Math.floor(Math.random() * 10000));

        const unitData = pseudo.choose(this.data.units);

        const unit = new Unit(unitData);
        unit.findComponent(Growing).spawn(slot);
    }
};

GrowingsPlanner.prototype.save = function () {
    if (!this.isAvailable()) {
        return;
    }

    this.slot.save("local_growings_planner", {
        time: this.spawnTime,
        order: this.spawnOrder
    });
};

GrowingsPlanner.prototype.load = function () {
    const data = this.slot.load("local_growings_planner");
    if (data) {
        this.spawnTime = data.time;
        this.spawnOrder = data.order;
    } else {
        this.spawnTime = Date.now();
        this.spawnOrder = 0;
        this.save();
    }
};

GrowingsPlanner.prototype.onRemoveGrowing = function () {
    if (this.planTimeout === undefined) {
        this.spawnTime = Date.now();
        this.spawnOrder = 0;
        this.save();
        this.planNext(this.getBetweenTimeout());
    }
};

GrowingsPlanner.prototype.isAvailable = function () {
    return !this.data.fog || Map2d.currentMap.fogs.isOpened(this.data.fog);
};

GrowingsPlanner.prototype.planNext = function (timeout) {
    this.clearPlanTimeout();

    if (!this.isAvailable()) {
        this.spawnTime = Date.now();
        this.planTimeout = setTimeout(this.planNext.bind(this, timeout), cleverapps.parseInterval(GrowingsPlanner.INIT_TIMEOUT));
        return;
    }

    let nextSpawnTime = this.spawnTime + timeout;

    let waitTime = 0;
    if (nextSpawnTime > Date.now()) {
        waitTime = nextSpawnTime - Date.now();
    }

    this.planTimeout = setTimeout(() => {
        this.clearPlanTimeout();

        if (this.amountGrowings() >= this.data.maxAmount) {
            return;
        }

        if (!this.existFreeSlot()) {
            nextSpawnTime = Date.now();
        } else {
            this.spawn();
        }

        this.spawnTime = nextSpawnTime;
        this.spawnOrder++;
        this.save();

        this.planNext(this.getBetweenTimeout());
    }, waitTime);
};

GrowingsPlanner.INIT_TIMEOUT = "30 seconds";

GrowingsPlanner.CONFIG = {};
